import React from "react";
import { useTheme } from "styled-components";

const TextAndTitle = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.813 3.938v8.437m7.312-4.219H2.813m7.312-4.218v8.437m5.625 2.25v-6.75L14.063 9"
        stroke={theme.text.text}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TextAndTitle;
